<template>
	<div class="pages">
		<sub-ibox-title>
			<p slot="title">裂变红包详情</p>
		</sub-ibox-title>
		<section class="content">
			<ul class="promotion-ditail">
				<li class="fx"><p>红包名称</p><div>{{envelopeInfo.info.name}}</div></li>
				<li class="fx"><p>适用门店</p>
					<div>
						<ol>
							<li v-for="item in envelopeInfo.info.use_shop_list || []">{{item.name}}</li>
						</ol>
					</div>
				</li>
				<li class="fx">
					<p>消费金额</p>
					<div v-if="envelopeInfo.info.send_rule.pay_fee">{{envelopeInfo.info.send_rule.pay_fee}}元</div>
					<div v-else>不限制</div>
				</li>
				<li class="fx"><p>发放红包个数</p><div>{{envelopeInfo.info.send_rule.count}}个</div></li>
				<li class="fx"><p>发放红包总金额</p><div>{{envelopeInfo.info.send_rule.amount}}元</div></li>
				<li class="fx"><p>单个红包最小金额</p><div>{{envelopeInfo.info.send_rule.single_min_amount}}元</div></li>
				<li class="fx"><p>单个红包最大金额</p><div>{{envelopeInfo.info.send_rule.single_max_amount}}元</div></li>
				<li class="fx">
					<p>使用条件</p>
					<div v-if="envelopeInfo.info.use_rule > 0">消费满{{envelopeInfo.info.use_rule | filterMoney}}元才能使用红包</div>
					<div v-else>不限制</div>
				</li>
			</ul>
		</section>
	</div>
</template>
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	.content {
		border-top: none;
	}
	.promotion-ditail{
		li{
			padding: px-em(10px) 0;
		}
		p{
			width: px-em(300px);
		}
	}
</style>
<script>
	import {
		mapState,
		mapActions
	} from 'vuex'
	export default {
		name: 'RedPackInfo',
		components: {},
		data() {
			return {
				id: '',
				envelopeInfo: {
					info: {
						name: '',
						send_rule: '',
						use_rule: {
							pay_fee: '',
							count: '',
							amount: '',
							single_min_amount: '',
							single_max_amount: ''
						},
						use_shop_list: []
					},
					shopList: [],
				}
			}
		},
		async mounted() {
			this.id = this.$route.query.envelopeId;
			if(this.$re_Number(this.id)) await this.handleGetEnvelopeInfo();	
		},
		methods: {
			//获取红包详情
			async handleGetEnvelopeInfo() {
				try {
					this.envelopeInfo.info = await this.getEnlopeInfo({id: this.id});
				} catch (e) {
					this.$warning(e);
				}
			},
			...mapActions(['getEnlopeInfo']),
		},
	}
</script>


// WEBPACK FOOTER //
// RedPackInfo.vue?5c8ffa28